module.exports = __webpack_public_path__ + "img/10.ababd26b.png";